/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand
 */
export interface FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand
     */
    Game: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand
     */
    GameJwtAccessTokenJwtString: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand interface.
 */
export function instanceOfFxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand(value: object): value is FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('GameJwtAccessTokenJwtString' in value) || value['GameJwtAccessTokenJwtString'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandFromJSON(json: any): FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand {
    return FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'GameJwtAccessTokenJwtString': json['GameJwtAccessTokenJwtString'],
    };
}

export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSON(json: any): FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand {
    return FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSONTyped(value?: FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'GameJwtAccessTokenJwtString': value['GameJwtAccessTokenJwtString'],
    };
}

